export default __webpack_public_path__ + "de709096fe1269de350d81f8e1255e98.png";